"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputMapPoint = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faMapMarkerAlt_1 = require("@fortawesome/free-solid-svg-icons/faMapMarkerAlt");
const project_config_1 = __importDefault(require("evolution-common/lib/config/project.config"));
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const react_i18next_1 = require("react-i18next");
// TODO Allow to support multiple maps and geocoders
const InputMapGoogle_1 = __importDefault(require("./maps/google/InputMapGoogle"));
const GoogleGeocoder_1 = require("./maps/google/GoogleGeocoder");
const SurveyErrorMessage_1 = __importDefault(require("../survey/widgets/SurveyErrorMessage"));
// Default max zoom and zoom
const defaultZoom = 13;
const defaultMaxZoom = 18;
/**
 * Allow to select a single point from a map.
 *
 * TODO For now, it only uses google map, but this class should remain map
 * agnostic and support more map types
 */
class InputMapPoint extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.geocodeButtonRef = react_1.default.createRef();
        this.onValueChange = (feature) => {
            this.props.onValueChange({ target: { value: feature } });
            this.setState({
                defaultCenter: feature
                    ? { lat: feature.geometry.coordinates[1], lon: feature.geometry.coordinates[0] }
                    : this.state.defaultCenter,
                markers: feature
                    ? [
                        {
                            position: feature,
                            icon: { url: this.iconUrl, size: this.iconSize },
                            draggable: true
                        }
                    ]
                    : []
            });
        };
        this.onMapReady = (bbox) => {
            // Do not render button until map is ready, to prevent flakiness when a test clicks the button too quickly.
            this.setState({ currentBounds: bbox, renderGeoCodeButton: true });
            if (!this.props.value) {
                this.geocodeAddress(bbox);
            }
        };
        this.onBoundsChanged = (bbox) => {
            this.setState({ currentBounds: bbox });
        };
        this.onGeocodeAddress = (e) => {
            e.preventDefault();
            this.geocodeAddress(this.state.currentBounds);
        };
        this.getGeocodingQueryString = () => {
            return this.props.widgetConfig.geocodingQueryString
                ? this.props.widgetConfig.geocodingQueryString(this.props.interview, this.props.path, this.props.user)
                : undefined;
        };
        this.geocodeAddress = (bbox) => __awaiter(this, void 0, void 0, function* () {
            const geocodingQueryString = this.getGeocodingQueryString();
            const geocodingQueryStringArray = typeof geocodingQueryString === 'string'
                ? [{ queryString: geocodingQueryString, zoom: defaultZoom }]
                : geocodingQueryString;
            if (geocodingQueryStringArray) {
                try {
                    // FIXME We may want to adapt this to support multiple geocoding queries, like in the inputMapFindPlace widget
                    const feature = yield (0, GoogleGeocoder_1.geocodeSinglePoint)(geocodingQueryStringArray[0].queryString, { bbox });
                    this.onValueChange(feature);
                    this.setState({ displayMessage: feature === undefined ? 'main:InputMapGeocodeNoResult' : undefined });
                }
                catch (_a) {
                    this.onValueChange(undefined);
                    this.setState({ displayMessage: 'main:InputMapGeocodeError' });
                }
            }
        });
        // get initial map center from current value or widget config (can be a function)
        const defaultCenter = props.value
            ? { lon: props.value.geometry.coordinates[0], lat: props.value.geometry.coordinates[1] }
            : surveyHelper.parse(props.widgetConfig.defaultCenter, props.interview, props.path, props.user) ||
                project_config_1.default.mapDefaultCenter;
        this.iconUrl = this.props.widgetConfig.icon
            ? surveyHelper.parseString(this.props.widgetConfig.icon.url, this.props.interview, this.props.path, this.props.user) || '/dist/images/default_marker.svg'
            : '/dist/images/default_marker.svg';
        this.iconSize =
            this.props.widgetConfig.icon && this.props.widgetConfig.icon.size
                ? this.props.widgetConfig.icon.size
                : [40, 40];
        this.state = {
            defaultCenter,
            currentBounds: undefined,
            renderGeoCodeButton: false,
            markers: this.props.value
                ? [
                    {
                        position: this.props.value,
                        icon: { url: this.iconUrl, size: this.iconSize },
                        draggable: true
                    }
                ]
                : []
        };
    }
    render() {
        const maxZoom = this.props.widgetConfig.maxZoom || defaultMaxZoom;
        const showSearchPlaceButton = this.props.widgetConfig.showSearchPlaceButton
            ? surveyHelper.parseBoolean(this.props.widgetConfig.showSearchPlaceButton, this.props.interview, this.props.path, this.props.user)
            : true;
        return (react_1.default.createElement("div", { className: 'survey-question__input-map-container' },
            react_1.default.createElement("input", { type: "hidden", className: 'apptr__form-input input-map-hidden', name: this.props.widgetConfig.shortname, id: this.props.id, defaultValue: JSON.stringify(this.props.value), readOnly: true, ref: this.props.inputRef }),
            this.props.widgetConfig.refreshGeocodingLabel && showSearchPlaceButton !== false && (react_1.default.createElement("button", { type: "button", id: `${this.props.id}_refresh`, className: "button refresh-geocode green large", onClick: this.onGeocodeAddress, ref: this.geocodeButtonRef, style: { display: this.state.renderGeoCodeButton ? 'inline' : 'none' } },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faMapMarkerAlt_1.faMapMarkerAlt, className: "faIconLeft" }),
                surveyHelper.translateString(this.props.widgetConfig.refreshGeocodingLabel, this.props.i18n, this.props.interview, this.props.path, this.props.user))),
            this.state.displayMessage && (react_1.default.createElement(SurveyErrorMessage_1.default, { containsHtml: false, text: this.props.t(this.state.displayMessage) })),
            react_1.default.createElement("div", { "aria-hidden": "true", className: "survey-question__input-map-container" },
                react_1.default.createElement(InputMapGoogle_1.default, { defaultCenter: this.state.defaultCenter, value: this.props.value, onValueChange: this.onValueChange, defaultZoom: Math.min(this.props.widgetConfig.defaultZoom || defaultZoom, maxZoom), markers: this.state.markers, onMapReady: this.onMapReady, onBoundsChanged: this.onBoundsChanged }))));
    }
}
exports.InputMapPoint = InputMapPoint;
exports.default = (0, react_i18next_1.withTranslation)()(InputMapPoint);
//# sourceMappingURL=InputMapPoint.js.map